import { createSlice } from "@reduxjs/toolkit";
import { NotificationStatus } from "../components/Notification/Notification";

export interface NotificationState {
    notification: {
        status: NotificationStatus | null,
        title: string | null,
        message: string | null
    },
    show: boolean
}

const initialState: NotificationState = {
    notification: {
        status: null,
        title: null,
        message: null
    },
    show: false
}

const NotificationSlice = createSlice({
    name: 'Ui',
    initialState,
    reducers: {
        showNotification(state: NotificationState, action: any) {
            state.notification = {
                status: action.payload.status,
                title: action.payload.title,
                message: action.payload.message
            };
            state.show = true;
        },
        hideNotification(state: NotificationState, action: any) {
            state.notification = {
                status: null,
                title: null,
                message: null
            };
            state.show = false;
        }
    }
});

export const NotificationActions = NotificationSlice.actions;

export default NotificationSlice;